import { Component, Input } from '@angular/core';

@Component({
  selector: 'email-sent',
  templateUrl: '../../templates/partials/email-sent.html'
})
export class EmailSentComponent{

  @Input() loginState;
}


// WEBPACK FOOTER //
// ./src/app/modules/login/components/dummy/email-sent.component.ts